export function isProductionDomain(hostname: string): boolean {
  const nonProductionDomains = [
    '.staging.',
    'localhost',
    'korints-projects.vercel.app',
    'rv-',
    '.develop.',
  ];
  return !nonProductionDomains.some(domain => hostname.includes(domain));
}
